import { Container } from "theme-ui";

import { Trove } from "../components/Trove/Trove";
import { Stability } from "../components/Stability/Stability";
import { SystemStats } from "../components/SystemStats";
import { Staking } from "../components/Staking/Staking";
import { Farm as FarmPanel } from "../components/Farm/Farm";
import { FarmSecond } from "../components/Farmlp/FarmSecond";
import { TradingPair } from "../components/Farm/TradingPair";
import { Staking2 } from "../components/SPrint/Staking";

export const Dashboard: React.FC = () => (
  <Container variant="columns">
    <Container variant="left">
      <Trove />
      <Stability />
      <Staking />
      <FarmPanel />
      <FarmSecond />
      <TradingPair />
    </Container>

    <Container variant="right">
      <SystemStats />
      <Staking2 />
    </Container>
  </Container>
);
